@if(isLoading) {
  <app-loader></app-loader>
}
<div class="home-container">
  <div class="quiz-form-section-container">
    <div class="logo-container">
      <img
        src="assets/WatchGuard_Logo.svg"
        alt="logo"
        height="80" 
        width="auto" 
        class="logo"
      />
    </div>
    
    <h1 class="red">{{ candidateFormUIString.organization_title }}</h1>
    <p>{{ candidateFormUIString.organization_description }}</p>
    <div class="message">
      <p class="verify-message">{{candidateFormUIString.verify_message}}</p>
      <p class="note-message">{{candidateFormUIString.note_message}}</p>
    </div>
  </div>
  <div class="quiz-form-section-container">
    <form
      class="candidate-form"
      [formGroup]="candidateDetailsForm"
    >
      <div class="candidate-form-input">
        <p-floatLabel>
          <input
            pInputText 
            id="code"
            type="text"
            formControlName="code"
          />
          <label for="code">
            {{candidateFormUIString.test_code}}
          </label>
        </p-floatLabel>
        <small 
          class="error-message"
          *ngIf="candidateDetailsForm.get('code')?.touched && 
            (!candidateDetailsForm.get('code')?.value)">
          code is required.
        </small>
        <small 
          class="error-message"
          *ngIf="candidateDetailsForm.get('code')?.value && 
            candidateDetailsForm.get('code')?.invalid">
          code is invalid.
        </small>
      </div>
      <div class="btn-center">
        <p-button
          type="submit"
          class="btn-design"
          severity="success"
          [label]="candidateFormUIString.verify_test"
          [outlined]="true"
          [disabled]="candidateDetailsForm.invalid || !browserIdReady"
          (click)="verifyCandidate()"
        ></p-button>
      </div>
    </form>
  </div>
</div>
